// src/pages/AuditTrail.jsx
import { useEffect, useState } from "react";
import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { db } from "../../services/firebase";

export default function AuditTrail() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Real-time listener for audit logs
    const q = query(collection(db, "auditLogs"), orderBy("timestamp", "desc"));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const fetched = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setLogs(fetched);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 p-6">
      <h2 className="text-2xl font-bold mb-6 text-gray-900 dark:text-white">
        Audit Trail
      </h2>

      {logs.length === 0 ? (
        <p className="text-gray-600 dark:text-gray-400 text-center">
          No activities recorded yet.
        </p>
      ) : (
        <div className="bg-white dark:bg-gray-800 shadow-md rounded-lg overflow-hidden">
          <table className="w-full text-sm text-left text-gray-700 dark:text-gray-300">
            <thead className="bg-gray-100 dark:bg-gray-700">
              <tr>
                <th className="px-4 py-3">Date</th>
                <th className="px-4 py-3">Role</th>
                <th className="px-4 py-3">Action</th>
                <th className="px-4 py-3">Details</th>
                <th className="px-4 py-3">Requester</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((log) => {
                // 🔓 Decode requester email (Base64)
                let decodedEmail = "";
                try {
                  decodedEmail = log.requester ? atob(log.requester) : "";
                } catch {
                  decodedEmail = "";
                }

                return (
                  <tr
                    key={log.id}
                    className="border-b border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
                  >
                    {/* Date */}
                    <td className="px-4 py-3 whitespace-nowrap">
                      {log.timestamp?.toDate
                        ? log.timestamp.toDate().toLocaleString()
                        : "—"}
                    </td>

                    {/* Role */}
                    <td className="px-4 py-3 capitalize">
                      {log.role || "Unknown"}
                    </td>

                    {/* Action */}
                    <td className="px-4 py-3 font-medium text-gray-900 dark:text-white">
                      {log.action || "—"}
                    </td>

                    {/* Message */}
                    <td className="px-4 py-3 text-gray-600 dark:text-gray-400">
                      {log.message || "No details"}
                    </td>

                    {/* Requester (Decrypted for admin) */}
                    <td className="px-4 py-3 text-xs text-gray-500 dark:text-gray-400">
                      {decodedEmail ? decodedEmail : "Hidden"}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
